<script setup>
import { gsap } from 'gsap'
import PlayIcon from '@/assets/img/ico/play.svg'
import CloseIcon from '@/assets/img/ico/close.svg'

const overlayElement = ref(null)
const overlayVideoElement = ref(null)
const closeButtonElement = ref(null)
const isFullScreen = ref(false)

const backgroundVideoSrc =
  'https://www.youtube-nocookie.com/embed/E6CjbSGKlCk?autoplay=1&amp;si=4kjmDTcnu406y72J&amp;controls=0&amp;mute=1&amp;loop=1&amp;playlist=E6CjbSGKlCk'
const overlayVideoSrc =
  'https://www.youtube-nocookie.com/embed/nIobuEFCSZE?autoplay=1&amp;si=NAywOAd1MKTevUQt&amp;controls=1&amp;mute=0&amp;loop=1&amp;playlist=nIobuEFCSZE'

const toggleFullScreen = async (event) => {
  if (event) {
    event.stopPropagation()
  }
  if (isFullScreen.value) {
    if (overlayVideoElement.value && overlayElement.value) {
      gsap
        .timeline()
        .to(overlayVideoElement.value, {
          opacity: 0,
          duration: 0.5,
          ease: 'power2.out',
        })
        .to(
          overlayElement.value,
          {
            x: '-100%',
            duration: 0.5,
            ease: 'power2.out',
          },
          '-=0.5',
        )
        .add(() => {
          isFullScreen.value = false
        })
    }
  } else {
    isFullScreen.value = true
    await nextTick()
    if (closeButtonElement.value) {
      closeButtonElement.value.classList.remove('hidden')
    }
    if (overlayElement.value && overlayVideoElement.value) {
      gsap
        .timeline()
        .fromTo(
          overlayElement.value,
          { x: '-100%' },
          { x: '0%', duration: 0.5, ease: 'power2.out' },
        )
        .fromTo(
          overlayVideoElement.value,
          { opacity: 0 },
          { opacity: 1, duration: 0.5, ease: 'power2.out' },
          '+=0.3',
        )
    }
  }
}

const closeOverlay = (event) => {
  event.stopPropagation()
  if (closeButtonElement.value) {
    closeButtonElement.value.classList.add('hidden')
  }
  toggleFullScreen(event)
}

watch(isFullScreen, async (newVal) => {
  await nextTick()
  if (newVal && overlayElement.value && overlayVideoElement.value) {
    gsap
      .timeline()
      .fromTo(
        overlayElement.value,
        { x: '-100%' },
        { x: '0%', duration: 0.5, ease: 'power2.out' },
      )
      .fromTo(
        overlayVideoElement.value,
        { opacity: 0 },
        { opacity: 1, duration: 0.5, ease: 'power2.out' },
        '+=0.3',
      )
  }
})
</script>

<template>
  <div class="video-youtube-wrap">
    <iframe
      class="background"
      :src="backgroundVideoSrc"
      title="YouTube video player"
      frameborder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; web-share"
      referrerpolicy="strict-origin-when-cross-origin"
      allowfullscreen
    ></iframe>

    <div class="play" @click="toggleFullScreen">
      <PlayIcon />
    </div>
  </div>
  <div v-if="isFullScreen" ref="overlayElement" class="overlay-youtube">
    <iframe
      ref="overlayVideoElement"
      :src="overlayVideoSrc"
      title="YouTube video player"
      frameborder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; web-share"
      referrerpolicy="strict-origin-when-cross-origin"
      allowfullscreen
    ></iframe>

    <div ref="closeButtonElement" class="close-button" @click="closeOverlay">
      <CloseIcon />
    </div>
  </div>
</template>

<script>
export default {
  name: 'WidgetVideoYoutube',
}
</script>

<style scoped lang="scss">
@import './style.scss';
</style>
